import React from "react";
import { Container } from "reactstrap";
import "bootstrap/dist/css/bootstrap.css";
import "./Body.css";

function Body() {
  return (
    <div className="body">
      <Container>
        <div>
          <h1> <b>Do you like free Fantasy and Sci-Fi stories?</b></h1>
        </div>
        <div className="substack-container">
          <a href="https://substack.com/@quinnthomasauthor"><img src="./Substack Example.png" className="substack" /></a>
        </div>
        <div className="row mt-3 about-text">
          <div>
            <p>
              My newsletter goes out on the first and third Friday of each month. Each edition includes:
            </p>
            <ul className="ml3">
              <li>
                Links to three giveaways where you can score free Fantasy and Sci-Fi ebooks, short stories, and samples from a number of indie authors
              </li>
              <li>
                Updates on new releases, my latest freebies, and works in progress
              </li>
              <li>
                An exclusive scene from my latest short stories, which my subscribers get first access to. Full short stories usually come out over the course of 7-12 newsletters.
              </li>
            </ul>
          </div>
          <div className="subscribe-container">
            <a href="https://substack.com/@quinnthomasauthor" className="subscribe-btn">Subscribe on Substack</a>
          </div>
        </div>
      </Container>
    </div>
  );
}
export default Body;
